import type {DropdownMenuListItem} from './types';

export const dropdownMenuSeparator: DropdownMenuListItem = {text: '', action: () => {}, path: []};
